"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IgReelIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_3870_2359)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M7.876 0l1.716 3.16h-3.56L4.318 0h3.559zm2.282 0c1.86 0 3.414 1.36 3.766 3.16h-2.6L9.607 0h.551zM2.684.183C1.364.612.352 1.751.076 3.16H4.3L2.684.183z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M0 10.065V4.71h14v5.355C14 12.235 12.276 14 10.158 14H3.842C1.724 14 0 12.235 0 10.065zm5.857 1.303L9.15 9.565a.697.697 0 000-1.214L5.857 6.547c-.448-.245-.99.088-.99.608v3.606c0 .52.542.853.99.607z",
    clipRule: "evenodd"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_3870_2359"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M0 0h14v14H0z"
  })))))
});
IgReelIcon.displayName = 'IgReelIcon';
var _default = exports.default = IgReelIcon;